/**
 * Thrown by `defineFlags` / `composeCatalog` when a catalog is constructed with
 * an illegal shape: an unknown mechanism prefix, a `type: 'variant'` flag on a
 * `wiring.*` key, or a duplicate key across fragments.
 *
 * These are build-time / module-load errors (the factories run at import time),
 * not runtime request errors — a bad catalog should fail the build, loudly.
 */
export class FlagCatalogError extends Error {
    public constructor(message: string) {
        super(message);
        this.name = 'FlagCatalogError';
    }
}
